import { ErrorBox } from "@gearbox-protocol/deploy-tools-ui";
import type { OnchainSDK } from "@gearbox-protocol/sdk/onchain";
import { type FC, useMemo } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { type SdkStateLanguage, serializeSdkState } from "utils";
import type { Address } from "viem";
import { CodeEditor } from "../editors";

export interface SDKViewProps {
  sdk: OnchainSDK | undefined;
  language: SdkStateLanguage;
  curator: Address | undefined;
  market: Address | undefined;
  creditManager: Address | undefined;
}

export const SDKView: FC<SDKViewProps> = props => {
  const { sdk, language, curator, market, creditManager } = props;
  const value = useMemo(() => {
    if (!sdk) {
      return undefined;
    }
    return serializeSdkState({
      sdk,
      language,
      filter: { curator, market, creditManager },
    });
  }, [sdk, language, curator, market, creditManager]);

  if (!value) {
    return null;
  }

  return (
    <ErrorBoundary FallbackComponent={ErrorBox as any}>
      <CodeEditor language={language} value={value} editable={false} />
    </ErrorBoundary>
  );
};
